const Constants = {
    MEMBERSHIP_ID: "MembershipUserId",
	DATE_FORMATE_DD_MM_YYYY: "DD/MM/YYYY",
	
	Session:{
		USER_OBJECT: "user_obj",
		ADMIN_OBJECT: "admin_obj",
		PARENT_OBJECT: "Parent_Obj",
		JWT_TOKEN: "jwt_token",
        AUTHENTICATION_TICKET: "AuthenticationTicket",
        ADDON_GROUP_ITEMS: "AddonGroupItems",
        ADDON_GROUP_IDs:"TableRecordIdsCsv",
		ALL_PERMISSION: "all_permission",
		ENTERPRISE_ID: "EnterpriseId",
		ENTERPRISE_NAME: "EnterpriseName",
		IMPERSONATORID: "ImpersonatorID",
		PARENTIMPERSONATORID: "ParentImpersonatorID",
		IS_MENU_MODIFIED: "IsMenuModified",
		SESSION_START_AT: "SessionStartAt",
		FORGOT_PASSWORD_OBJECT: "ForgotPasswordInfo",
		NEW_ORDER_LIST: "NewOrderList",
		SELECTED_ORDER_STATUS: "SelectedOrderStatus",
		CATEGORY_EXPANDALL: "Category_ExpandAll",
		CONFIGURATION_TAB: "Configuration_Tab",
		SITE_URL: "SiteUrl",
    },
	Cookies:{
		USER_EMAIL: "user",
		USER_PASSWORD: "auth",
    },

	SubscriptionFeatures: {
		DELIVERY_ZONE: "delivery_zone",
		STAFF_ACCOUNT: "staff_account",
		WHATSAPP_ALERT: "whatsapp_alert"
	},

    MenuAddonGroupTopping: "0",
    MenuAddonGroupExtra: "1",
    Permission: {
		
		//#region ENTERPRISE_SETTING Constants

		ENTERPRISE_SETTING_READ : "ENTERPRISE_SETTING_READ",
		ENTERPRISE_SETTING_UPDATE : "ENTERPRISE_SETTING_UPDATE",

	   //#endregion

		
		//#region SYSTEM_OPERATOR Constants

		 SYSTEM_OPERATOR_CREATE : "SYSTEM_OPERATOR_CREATE",
		 SYSTEM_OPERATOR_READ : "SYSTEM_OPERATOR_READ",
		 SYSTEM_OPERATOR_UPDATE : "SYSTEM_OPERATOR_UPDATE",
		 SYSTEM_OPERATOR_DELETE : "SYSTEM_OPERATOR_DELETE",
		 SYSTEM_OPERATOR_SUSPEND : "SYSTEM_OPERATOR_SUSPEND",
		 SYSTEM_OPERATOR_ACTIVATE : "SYSTEM_OPERATOR_ACTIVATE",
		 SYSTEM_OPERATOR_IMPERSONATE : "SYSTEM_OPERATOR_IMPERSONATE",

		//#endregion

		//#region Marketing Admin	Constants

		MARKETING_ADMIN_ADMIN : "MARKETING_ADMIN_ADMIN",

		//#endregion

		//#region Foortal ENTERPRISE Admin
		
		FOORTAL_ENTERPRISE_ADMIN_ADMIN : "FOORTAL_ENTERPRISE_ADMIN_ADMIN",
		
		//#endregion

		//#region Foortal ENTERPRISE User

		FOORTAL_ENTERPRISE_USER_ADMIN : "FOORTAL_ENTERPRISE_USER_ADMIN",
		
		//#endregion

		//#region Foortal Support Admin

		 FOORTAL_SUPPORT_ADMIN_ADMIN : "FOORTAL_SUPPORT_ADMIN_ADMIN",

		//#endregion

		//#region Foortal Support User

		 FOORTAL_SUPPORT_USER_ADMIN : "FOORTAL_SUPPORT_USER_ADMIN",

		//#endregion



		//#region AGENT constants

		 AGENT_CREATE : "AGENT_CREATE",
		 AGENT_READ : "AGENT_READ",
		 AGENT_UPDATE : "AGENT_UPDATE",
		 AGENT_DELETE : "AGENT_DELETE",
		 AGENT_SUSPEND : "AGENT_SUSPEND",
		 AGENT_ACTIVATE : "AGENT_ACTIVATE",
		 AGENT_IMPERSONATE : "AGENT_IMPERSONATE",

		//#endregion

		//#region ENTERPRISE_ADMIN

		 ENTERPRISE_ADMIN_CREATE : "ENTERPRISE_ADMIN_CREATE",
		 ENTERPRISE_ADMIN_READ : "ENTERPRISE_ADMIN_READ",
		 ENTERPRISE_ADMIN_UPDATE : "ENTERPRISE_ADMIN_UPDATE",
		 ENTERPRISE_ADMIN_DELETE : "ENTERPRISE_ADMIN_DELETE",
		 ENTERPRISE_ADMIN_SUSPEND : "ENTERPRISE_ADMIN_SUSPEND",
		 ENTERPRISE_ADMIN_ACTIVATE : "ENTERPRISE_ADMIN_ACTIVATE",
		 ENTERPRISE_ADMIN_IMPERSONATE : "ENTERPRISE_ADMIN_IMPERSONATE",
		 ENTERPRISE_ADMIN_APPROVED : "ENTERPRISE_ADMIN_APPROVED",

		//#endregion

		//#region ENTERPRISE_MANAGER

		 ENTERPRISE_MANAGER_CREATE : "ENTERPRISE_MANAGER_CREATE",
		 ENTERPRISE_MANAGER_READ : "ENTERPRISE_MANAGER_READ",
		 ENTERPRISE_MANAGER_UPDATE : "ENTERPRISE_MANAGER_UPDATE",
		 ENTERPRISE_MANAGER_DELETE : "ENTERPRISE_MANAGER_DELETE",
		 ENTERPRISE_MANAGER_SUSPEND : "ENTERPRISE_MANAGER_SUSPEND",
		 ENTERPRISE_MANAGER_ACTIVATE : "ENTERPRISE_MANAGER_ACTIVATE",
		 ENTERPRISE_MANAGER_IMPERSONATE : "ENTERPRISE_MANAGER_IMPERSONATE",
		 ENTERPRISE_MANAGER_APPROVED : "ENTERPRISE_MANAGER_APPROVED",

		//#endregion

		//#region   ENTERPRISE_USER

		 ENTERPRISE_USER_CREATE : "ENTERPRISE_USER_CREATE",
		 ENTERPRISE_USER_READ : "ENTERPRISE_USER_READ",
		 ENTERPRISE_USER_UPDATE : "ENTERPRISE_USER_UPDATE",
		 ENTERPRISE_USER_DELETE : "ENTERPRISE_USER_DELETE",
		 ENTERPRISE_USER_SUSPEND : "ENTERPRISE_USER_SUSPEND",
		 ENTERPRISE_USER_ACTIVATE : "ENTERPRISE_USER_ACTIVATE",
		 ENTERPRISE_USER_IMPERSONATE : "ENTERPRISE_USER_IMPERSONATE",
		 ENTERPRISE_USER_APPROVED : "ENTERPRISE_USER_APPROVED",

		//#endregion

		//#region  CONSUMER

		 CONSUMER_READ : "ENTERPRISE_USER_APPROVED",
		 CONSUMER_UPDATE : "CONSUMER_UPDATE",
		 CONSUMER_DELETE : "CONSUMER_DELETE",
		 CONSUMER_SUSPEND : "CONSUMER_SUSPEND",
		 CONSUMER_ACTIVATE : "CONSUMER_ACTIVATE",
		 CONSUMER_IMPERSONATE : " CONSUMER_IMPERSONATE",
		 CONSUMER_APPROVED : "CONSUMER_APPROVED",

		//#endregion

		//#region  ADVERTISER

		 ADVERTISER_CREATE : "ADVERTISER_CREATE",
		 ADVERTISER_READ : "ADVERTISER_READ",
		 ADVERTISER_UPDATE : "ADVERTISER_UPDATE",
		 ADVERTISER_DELETE : "ADVERTISER_DELETE",
		 ADVERTISER_SUSPEND : "ADVERTISER_DELETE",
		 ADVERTISER_ACTIVATE : "ADVERTISER_ACTIVATE",
		 ADVERTISER_IMPERSONATE : "ADVERTISER_IMPERSONATE",
		 ADVERTISER_APPROVED : "ADVERTISER_APPROVED",

		//#endregion

		//#region  FINANCE

		 FINANCE_CREATE : "FINANCE_CREATE",
		 FINANCE_READ : "FINANCE_READ",
		 FINANCE_UPDATE : "FINANCE_UPDATE",
		 FINANCE_DELETE : "FINANCE_DELETE",
		 FINANCE_SUSPEND : "FINANCE_SUSPEND",
		 FINANCE_ACTIVATE : "FINANCE_ACTIVATE",
		 FINANCE_IMPERSONATE : "FINANCE_IMPERSONATE",
		 FINANCE_APPROVED : "FINANCE_APPROVED",

		//#endregion

		//#region  AGENT_COMMISSION

		 AGENT_COMMISSION_CREATE : "AGENT_COMMISSION_CREATE",
		 AGENT_COMMISSION_READ : "AGENT_COMMISSION_READ",
		 AGENT_COMMISSION_UPDATE : "AGENT_COMMISSION_UPDATE",
		 AGENT_COMMISSION_DELETE : "AGENT_COMMISSION_DELETE",

		//#endregion

		//#region    ENTERPRISE_COMMISSION

		 ENTERPRISE_COMMISSION_CREATE : "ENTERPRISE_COMMISSION_CREATE",
		 ENTERPRISE_COMMISSION_READ : "ENTERPRISE_COMMISSION_READ",
		 ENTERPRISE_COMMISSION_UPDATE : "ENTERPRISE_COMMISSION_UPDATE",
		 ENTERPRISE_COMMISSION_DELETE : "ENTERPRISE_COMMISSION_DELETE",

		//#endregion

		//#region  ENTERPRISE_ENTERPRISE

		 ENTERPRISE_ENTERPRISE_CREATE : "ENTERPRISE_ENTERPRISE_CREATE",
		 ENTERPRISE_ENTERPRISE_READ : "ENTERPRISE_ENTERPRISE_READ",
		 ENTERPRISE_ENTERPRISE_UPDATE : "ENTERPRISE_ENTERPRISE_UPDATE",
		 ENTERPRISE_ENTERPRISE_DELETE : "ENTERPRISE_ENTERPRISE_DELETE",
		 ENTERPRISE_ENTERPRISE_SUSPEND : "ENTERPRISE_ENTERPRISE_SUSPEND",
		 ENTERPRISE_ENTERPRISE_ACTIVATE : "ENTERPRISE_ENTERPRISE_ACTIVATE",
		 ENTERPRISE_ENTERPRISE_IMPERSONATE : "ENTERPRISE_ENTERPRISE_IMPERSONATE",
		 ENTERPRISE_ENTERPRISE_APPROVED : "ENTERPRISE_ENTERPRISE_APPROVED",
		 ENTERPRISE_ENTERPRISE_REGISTER : "ENTERPRISE_ENTERPRISE_REGISTER",
		 ENTERPRISE_CHURNED_UPDATE : "ENTERPRISE_CHURNED_UPDATE",
		//#endregion

		//#region  ENTERPRISE_GROUP

		 ENTERPRISE_GROUP_CREATE : "ENTERPRISE_GROUP_CREATE",
		 ENTERPRISE_GROUP_READ : "ENTERPRISE_GROUP_READ",
		 ENTERPRISE_GROUPUPDATE : "ENTERPRISE_GROUP_UPDATE",
		 ENTERPRISE_GROUP_DELETE : "ENTERPRISE_GROUP_DELETE",
		//#endregion

		//#region   GLOBAL_SETTING

		 GLOBAL_SETTING_CREATE : "GLOBAL_SETTING_CREATE",
		 GLOBAL_SETTING_READ : "GLOBAL_SETTING_READ",
		 GLOBAL_SETTING_UPDATE : "GLOBAL_SETTING_UPDATE",
		 GLOBAL_SETTING_DELETE : "GLOBAL_SETTING_DELETE",

		//#endregion

		//#region REPORTS

		 REPORTS_READ : "REPORTS_READ",

		//#endregion

		//#region  COUNTY_STATE_CITY

		 COUNTY_STATE_CITY_CREATE : "COUNTY_STATE_CITY_CREATE",
		 COUNTY_STATE_CITY_READ : "COUNTY_STATE_CITY_READ",
		 COUNTY_STATE_CITY_UPDATE : "COUNTY_STATE_CITY_UPDATE",
		 COUNTY_STATE_CITY_DELETE : "COUNTY_STATE_CITY_DELETE",
		 COUNTY_STATE_CITY_APPROVED : "COUNTY_STATE_CITY_APPROVED",

		//#endregion

		//#region  COUNTRIES

		 COUNTRIES_CREATE : "COUNTRIES_CREATE",
		 COUNTRIES_READ : "COUNTRIES_READ",
		 COUNTRIES_UPDATE : "COUNTRIES_UPDATE",
		 COUNTRIES_DELETE : "COUNTRIES_DELETE",
		 COUNTRIES_APPROVED : "COUNTRIES_APPROVED",

		//#endregion

		//#region AREA

		 AREA_CREATE : "AREA_CREATE",
		 AREA_READ : "AREA_READ",
		 AREA_UPDATE : "AREA_UPDATE",
		 AREA_DELETE : "AREA_DELETE",

		//#endregion

		//#region AREA MAPPING

		 AREA_MAPPING_CREATE : "AREA_MAPPING_CREATE",
		 AREA_MAPPING_READ : "AREA_MAPPING_READ",
		 AREA_MAPPING_UPDATE : "AREA_MAPPING_UPDATE",
		 AREA_MAPPING_DELETE : "AREA_MAPPING_DELETE",

		//#endregion

		//#region PHOTO

		 PHOTO_CREATE : "PHOTO_CREATE",
		 PHOTO_READ : "PHOTO_READ",
		 PHOTO_UPDATE : "PHOTO_UPDATE",
		 PHOTO_DELETE : "PHOTO_DELETE",
		 PHOTO_SUSPEND : "PHOTO_SUSPEND",
		 PHOTO_ACTIVATE : "PHOTO_ACTIVATE",
		 PHOTO_APPROVED : "PHOTO_APPROVED",
		 PHOTO_UN_APPROVED : "PHOTO_UN_APPROVED",

		//#endregion

		//#region   ASOSIATE_USER

		 ASOSIATE_USER_ENTERPRISE_READ : "ASOSIATE_USER_ENTERPRISE_READ",
		 ASOSIATE_USER_ENTERPRISE_UPDATE : "ASOSIATE_USER_ENTERPRISE_UPDATE",

		//#endregion region

		//#region  ENTERPRISE_CATEGORY

		 ENTERPRISE_CATEGORY_CREATE : "ENTERPRISE_CATEGORY_CREATE",
		 ENTERPRISE_CATEGORY_READ : "ENTERPRISE_CATEGORY_READ",
		 ENTERPRISE_CATEGORY_UPDATE : "ENTERPRISE_CATEGORY_UPDATE",
		 ENTERPRISE_CATEGORY_DELETE : "ENTERPRISE_CATEGORY_DELETE",
		 ENTERPRISE_CATEGORY_PUBLISHED : "ENTERPRISE_CATEGORY_PUBLISHED",
		 ENTERPRISE_CATEGORY_UN_PUBLISHED : "ENTERPRISE_CATEGORY_UN_PUBLISHED",

		//#endregion

		//#region ENTERPRISE_ITEM

		 ENTERPRISE_ITEM_CREATE : "ENTERPRISE_ITEM_CREATE",
		 ENTERPRISE_ITEM_READ : "ENTERPRISE_ITEM_READ",
		 ENTERPRISE_ITEM_UPDATE : "ENTERPRISE_ITEM_UPDATE",
		 ENTERPRISE_ITEM_DELETE : "ENTERPRISE_ITEM_DELETE",
		 ENTERPRISE_ITEM_PUBLISHED : "ENTERPRISE_ITEM_PUBLISHED",
		 ENTERPRISE_ITEM_UN_PUBLISHED : "ENTERPRISE_ITEM_UN_PUBLISHED",

		//#endregion

		//#region   ENTERPRISE_TOPPING_GROUP

		 ENTERPRISE_TOPPING_GROUP_CREATE : "ENTERPRISE_TOPPING_GROUP_CREATE",
		 ENTERPRISE_TOPPING_GROUP_READ : "ENTERPRISE_TOPPING_GROUP_READ",
		 ENTERPRISE_TOPPING_GROUP_UPDATE : "ENTERPRISE_TOPPING_GROUP_UPDATE",
		 ENTERPRISE_TOPPING_GROUP_DELETE : "ENTERPRISE_TOPPING_GROUP_DELETE",
		 ENTERPRISE_TOPPING_GROUP_APPROVED : "ENTERPRISE_TOPPING_GROUP_APPROVED",
		 ENTERPRISE_TOPPING_GROUP_UN_APPROVED : "ENTERPRISE_TOPPING_GROUP_UN_APPROVED",
		

		//#endregion

		//#region ENTERPRISE_TOPPING

		 ENTERPRISE_TOPPING_CREATE : "ENTERPRISE_TOPPING_CREATE",
		 ENTERPRISE_TOPPING_READ : "ENTERPRISE_TOPPING_READ",
		 ENTERPRISE_TOPPING_UPDATE : "ENTERPRISE_TOPPING_UPDATE",
		 ENTERPRISE_TOPPING_DELETE : "ENTERPRISE_TOPPING_DELETE",
		 ENTERPRISE_TOPPING_APPROVED : "ENTERPRISE_TOPPING_APPROVED",
		 ENTERPRISE_TOPPING_UN_APPROVED : "ENTERPRISE_TOPPING_UN_APPROVED",

		//#endregion

		//#region  ENTERPRISE_DEAL

		 ENTERPRISE_DEAL_CREATE : " ENTERPRISE_DEAL_CREATE",
		 ENTERPRISE_DEAL_READ : "ENTERPRISE_DEAL_READ",
		 ENTERPRISE_DEAL_UPDATE : "ENTERPRISE_DEAL_UPDATE",
		 ENTERPRISE_DEAL_DELETE : "ENTERPRISE_DEAL_DELETE",
		 ENTERPRISE_DEAL_APPROVED : "ENTERPRISE_DEAL_APPROVED",
		 ENTERPRISE_DEAL_UN_APPROVED : "ENTERPRISE_DEAL_UN_APPROVED",

		//#endregion

		//#region  ENTERPRISE_PROMOTION

		 ENTERPRISE_PROMOTION_CREATE : "ENTERPRISE_PROMOTION_CREATE",
		 ENTERPRISE_PROMOTION_READ : "ENTERPRISE_PROMOTION_READ",
		 ENTERPRISE_PROMOTION_UPDATE : "ENTERPRISE_PROMOTION_UPDATE",
		 ENTERPRISE_PROMOTION_DELETE : "ENTERPRISE_PROMOTION_DELETE",
		 ENTERPRISE_PROMOTION_APPROVED : "ENTERPRISE_PROMOTION_APPROVED",
		 ENTERPRISE_PROMOTION_UN_APPROVED : "ENTERPRISE_PROMOTION_UN_APPROVED",

		//#endregion

		//#region   ENTERPRISE_ORDER

		 ENTERPRISE_ORDER_READ : "ENTERPRISE_ORDER_READ",
		 ENTERPRISE_ORDER_UPDATE : "ENTERPRISE_ORDER_UPDATE",
		 ENTERPRISE_ORDER_DELETE : "ENTERPRISE_ORDER_DELETE",
		 ENTERPRISE_ORDER_APPROVED : "ENTERPRISE_ORDER_APPROVED",
		 ENTERPRISE_ORDER_UN_APPROVED : "ENTERPRISE_ORDER_APPROVED",

		//#endregion

		//#region  VOUCHERS

		 VOUCHERS_CREATE : "VOUCHERS_CREATE",
		 VOUCHERS_READ : "VOUCHERS_READ",
		 VOUCHERS_UPDATE : "VOUCHERS_UPDATE",
		 VOUCHERS_DELETE : "VOUCHERS_DELETE",
		 VOUCHERS_SUSPEND : "VOUCHERS_SUSPEND",
		 VOUCHERS_ACTIVATE : "VOUCHERS_ACTIVATE",
		 VOUCHERS_APPROVED : "VOUCHERS_APPROVED",
		 VOUCHERS_UN_APPROVED : "VOUCHERS_UN_APPROVED",

		//#endregion

		//#region CONTACT

		 CONTACT_CREATE : "CONTACT_CREATE",
		 CONTACT_READ : "CONTACT_READ",
		 CONTACT_UPDATE : "CONTACT_UPDATE",
		 CONTACT_DELETE : "CONTACT_DELETE",
		 CONTACT_SHARE : "CONTACT_SHARE",
		 CONTACT_GROUP_CREATE : "CONTACT_GROUP_CREATE",
		 CONTACT_GROUP_READ : "CONTACT_GROUP_READ",
		 CONTACT_GROUP_UPDATE : "CONTACT_GROUP_UPDATE",
		 CONTACT_GROUP_DELETE : "CONTACT_GROUP_DELETE",

		//#endregion

		//#region    USER_GROUP

		 USER_GROUP_CREATE : "USER_GROUP_CREATE",
		 USER_GROUP_READ : "USER_GROUP_READ",
		 USER_GROUP_UPDATE : " USER_GROUP_UPDATE",
		 USER_GROUP_DELETE : "USER_GROUP_DELETE",

		//#endregion

		//#region TOPUP

		 TOPUP_UPDATE : "TOPUP_UPDATE",

		//#endregion

		//#region   PROFILE

		 PROFILE_CREATE : "PROFILE_CREATE",
		 PROFILE_READ : "PROFILE_READ",
		 PROFILE_UPDATE : "PROFILE_UPDATE",
		 PROFILE_DELETE : "PROFILE_DELETE",

		//#endregion

		//#region DELIVERY AREA

		 ENTERPRISE_DELIVERY_AREA_READ : "ENTERPRISE_DELIVERY_AREA_READ",
		 ENTERPRISE_DELIVERY_AREA_CREATE : "ENTERPRISE_DELIVERY_AREA_CREATE",
		 ENTERPRISE_DELIVERY_AREA_UPDATE : "ENTERPRISE_DELIVERY_AREA_UPDATE",
		 ENTERPRISE_DELIVERY_AREA_DELETE : "ENTERPRISE_DELIVERY_AREA_DELETE",
		 ENTERPRISE_DELIVERY_AREA_ADMIN : "ENTERPRISE_DELIVERY_AREA_ADMIN",

		//#endregion

		//#region OFFER

		 ENTERPRISE_OFFER_READ : "ENTERPRISE_OFFER_READ",
		 ENTERPRISE_OFFER_CREATE : "ENTERPRISE_OFFER_CREATE",
		 ENTERPRISE_OFFER_UPDATE : "ENTERPRISE_OFFER_UPDATE",
		 ENTERPRISE_OFFER_DELETE : "ENTERPRISE_OFFER_DELETE",

		//#endregion				  

		//#region ADVERTISEMENT

		 ADVERTISEMENT_CREATE : "ADVERTISEMENT_CREATE",
		 ADVERTISEMENT_READ : "ADVERTISEMENT_READ",
		 ADVERTISEMENT_UPDATE : "ADVERTISEMENT_UPDATE",
		 ADVERTISEMENT_DELETE : "ADVERTISEMENT_DELETE",

		//#endregion 

		//#region Notification Constant
		
		 SMS_CASTER_ADMIN : "SMS_CASTER_ADMIN",
		 EMAIL_CASTER_ADMIN : "EMAIL_CASTER_ADMIN",
		 MOBILE_NOTIFICATION : "MOBILE_NOTIFICATION",
		
		//#endregion

	//#region FAKE ORDER REQUEST TICKETS

		 FAKE_ORDER_REQUEST_TICKET_READ : "FAKE_ORDER_REQUEST_TICKET_READ",
		 FAKE_ORDER_REQUEST_TICKET_UPDATE : "FAKE_ORDER_REQUEST_TICKET_UPDATE",
		 FAKE_ORDER_REQUEST_TICKET_CREATE : "FAKE_ORDER_REQUEST_TICKET_CREATE",

		//#endregion


		//#region IMPORT CONTACTS

		 ENTERPRISE_IMPORT_BULK_CONTACTS_ADMIN : "ENTERPRISE_IMPORT_BULK_CONTACTS_ADMIN",

        //#endregion

        //#region INVOICES
         INVOICES_READ : "INVOICES_READ",

		//#endregion
		
		  //#region CAMPAIGN
		  CAMPAIGN_READ : "CAMPAIGN_READ",
		  CAMPAIGN_CREATE : "CAMPAIGN_CREATE",
		  CAMPAIGN_UPDATE : "CAMPAIGN_UPDATE",
		  CAMPAIGN_SUSPEND : "CAMPAIGN_SUSPEND",
		  CAMPAIGN_ACTIVATE : "CAMPAIGN_ACTIVATE",

		  //#endregion

    },

    Role : {


        //#region Role Constants

		 SYSTEM_ADMIN : "System_Admin",
		 SYSTEM_OPERATOR : "System_Operator",
		 AGENT : "Agent",
		 ENTERPRISE_ADMIN : "Enterprise_Admin",
		 ENTERPRISE_MANAGER : "Enterprise_Manager",
		 ENTERPRISE_USER : "Enterprise_User",
		 CORPORATE_ADMIN : "Corporate_Admin",
		 ANONYMOUS : "Anonymous",
		 CONSUMER : "Consumer",
		 ADVERTISER : "Advertiser",
		 MARKETING_ADMIN : "Marketing_Admin",
		 FOORTAL_ENTERPRISE_ADMIN : "Foortal_ENTERPRISE_Admin",
		 FOORTAL_ENTERPRISE_USER : "Foortal_ENTERPRISE_User",
		 FOORTAL_SUPPORT_ADMIN : "Foortal_Support_Admin",
		 FOORTAL_SUPPORT_USER : "Foortal_Support_User",

		//#endregion

        //#region Role Constants IDs
        
		 SYSTEM_ADMIN_ID : 1,
		 SYSTEM_OPERATOR_ID : 2,
		 AGENT_ID : 3,
		 ENTERPRISE_ADMIN_ID : 4,
		 ENTERPRISE_MANAGER_ID : 5,
		 ENTERPRISE_USER_ID : 6,
		 CORPORATE_ADMIN_ID : 7,
		 ANONYMOUS_ID : 8,
		 CONSUMER_ID : 0,
		 ADVERTISER_ID : 9,
		 FINANCE_ID : 10,
		 MARKETING_ADMIN_ID : 11,
		 FOORTAL_ENTERPRISE_ADMIN_ID : 12,
		 FOORTAL_ENTERPRISE_USER_ID : 13,
		 FOORTAL_SUPPORT_ADMIN_ID : 14,
		 FOORTAL_SUPPORT_USER_ID : 15,

		//#endregion

    },

	//Setting Overview Constant

	SetingsOptions: [

		{ name: 'General Settings', url: '/settings/general', icon:'fa fa-cog icons'},
		{ name: 'Addresses', url: '/settings/addresses', icon:'fa fa-home icons'},
		{ name: 'Media', url: '/settings/media', icon:'fa fa-picture-o icons'},
		{ name: 'Working Hours', url: '/settings/working-hours', icon:'fa fa-history icons'},
		{ name: 'Delivery Hours', url: '/settings/delivery-hours', icon:'fa fa-motorcycle icons'},
		{ name: 'Delivery Zones', url: '/settings/deliveryzones', icon:'fa fa-map-marker icons'},
	]

}

export default Constants;